import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Subscription, BehaviorSubject } from 'rxjs';

export interface FilingBatchAccountsGridActionCellRendererParams extends ICellRendererParams {
    editMode$: BehaviorSubject<boolean>;

    canEdit(params: FilingBatchAccountsGridActionCellRendererParams): boolean;

    remove: (params: FilingBatchAccountsGridActionCellRendererParams) => void;
    undoRemove: (params: FilingBatchAccountsGridActionCellRendererParams) => void;

    canRemove(params: FilingBatchAccountsGridActionCellRendererParams): boolean;

    canUndoRemove(params: FilingBatchAccountsGridActionCellRendererParams): boolean;

    edit: (params: FilingBatchAccountsGridActionCellRendererParams) => void;
}

@Component({
    selector: 'filing-batch-accounts-grid-action-cell',
    template:
        `
    @if (params.canEdit(params)) {
      <button type="button"
        class="ace-btn has-icon btn-primary grid-action-button"
        (click)="onEditClicked()"
        helpTooltip
        helpContentId="filing-batch-accounts.edit-filing"
        position="bottom">
        <i class="fa fa-pencil"></i>
      </button>
    }
    @if (params.canRemove(params)) {
      <button
        type="button"
        class="ace-btn has-icon btn-primary btn-danger grid-action-button"
        (click)="onRemoveClicked()"
        helpTooltip
        helpContentId="app.remove"
        position="bottom">
        <i class="fa fa-times"></i>
      </button>
    }
    @if (params.canUndoRemove(params)) {
      <button
        type="button"
        class="ace-btn has-icon success-button grid-action-button"
        (click)="onUndoRemoveClicked()"
        helpTooltip
        helpContentId="app.undo-remove"
        position="bottom">
        <i class="fa fa-undo"></i>
      </button>
    }
    `,
    standalone: false
})
export class FilingBatchAccountsGridActionCellRendererComponent implements ICellRendererAngularComp, OnDestroy {
    params: FilingBatchAccountsGridActionCellRendererParams;
    private _editModeSub: Subscription;

    editMode: boolean;

    agInit(params: FilingBatchAccountsGridActionCellRendererParams): void {
        this.params = params;
        this._editModeSub = this.params.editMode$.subscribe(x => this.editMode = x);
    }

    ngOnDestroy(): void {
        this._editModeSub.unsubscribe();
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }

    onRemoveClicked(): void {
        this.params.remove(this.params);
    }

    onUndoRemoveClicked(): void {
        this.params.undoRemove(this.params);
    }

    onEditClicked(): void {
        this.params.edit(this.params);
    }
}
